import { FinancialReport } from 'utils/metrics/financialReports';
import { LocalDate } from 'js-joda';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { createWorkflowState, handleWorkflowDone } from '@tock/shared/workflow/workflowMonitor';
import { dashboard } from 'types';
import { payloadToJSON } from '@tock/coretypes';
import metrics from 'utils/metrics';

export const initialState: FinancialReport = {
  endDate: LocalDate.now().toString(),
  everInitialized: false,
  isInitialized: false,
  reports: {},
  selectedBusinessFilter: null,
  selectedMetricFilter: metrics.ServicedPayments.name,
  selectedTicketTypeFilter: 'ALL',
  selectedTicketTypeIds: [],
  startDate: LocalDate.now().minusDays(29).toString(),
  workflow: createWorkflowState(),
};

export default function reducer(state = initialState, action: BaseTockAction): FinancialReport {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.REPORTING_FETCH_ALL_DONE: {
      const result = payloadToJSON<dashboard.ReportQueriesResponse>(payload);
      const resultMap = result.response.reduce<FinancialReport['reports']>(
        (acc, r) => ({ ...acc, [`${r.reportName}`]: r.datapoint ?? [] }),
        {}
      );

      return {
        ...state,
        reports: { ...state.reports, ...resultMap },
        isInitialized: true,
        everInitialized: true,
      };
    }

    case SharedAppConstants.REPORTING_FETCH_WORKFLOW_DONE:
    case SharedAppConstants.REPORTING_FETCH_ALL_ASYNC_DONE: {
      return {
        ...state,
        workflow: handleWorkflowDone(state.workflow, action.payload),
      };
    }

    case SharedAppConstants.REPORTING_FETCH_WORKFLOW_RESULTS_DONE: {
      const result = payloadToJSON<dashboard.ReportQueriesResponse>(payload);
      const resultMap = result.response.reduce<FinancialReport['reports']>(
        (acc, r) => ({ ...acc, [`${r.reportName}`]: r.datapoint ?? [] }),
        {}
      );

      return {
        ...state,
        workflow: {
          ...state.workflow,
          isInitialized: true,
          data: { ...resultMap },
        },
      };
    }

    case SharedAppConstants.REPORTING_FETCH_WORKFLOW_FAILED:
    case SharedAppConstants.REPORTING_FETCH_ALL_ASYNC_FAILED: {
      return {
        ...state,
        workflow: {
          ...state.workflow,
          isInitialized: true,
          hasError: true,
        },
      };
    }

    case SharedAppConstants.REPORTING_FETCH_ALL_FAILED:
      return {
        ...state,
        isInitialized: true,
      };

    case SharedAppConstants.REPORTING_SELECT_BUSINESS_FILTER: {
      return {
        ...state,
        selectedBusinessFilter: payload,
      };
    }

    case SharedAppConstants.REPORTING_SELECT_METRIC_FILTER: {
      return {
        ...state,
        selectedMetricFilter: payload,
      };
    }

    case SharedAppConstants.REPORTING_SELECT_TICKET_TYPE_FILTER: {
      return {
        ...state,
        selectedTicketTypeFilter: payload.filter,
        selectedTicketTypeIds: payload.ticketTypeIds,
      };
    }

    case SharedAppConstants.REPORTING_SELECT_DATE_RANGE_FILTER: {
      return {
        ...state,
        startDate: payload.start,
        endDate: payload.end,
      };
    }

    case SharedAppConstants.REPORTING_FETCH_ALL_ASYNC_STARTING:
    case SharedAppConstants.REPORTING_FETCH_ALL_STARTING:
    case SharedAppConstants.REPORTING_CLEAR: {
      return {
        ...state,
        reports: {},
        workflow: { isInitialized: false, isRequesting: false },
        isInitialized: false,
      };
    }

    default:
      return state;
  }
}
